import { Service, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Notificari } from '../../../shared/models/nav-notificari.model';

import { ApiService } from '../../../shared/services/api.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';

import { AlertStore } from '../../../shared/state/alert.store';
import { executa } from '../../../shared/services/executa';

@Service()
export class NavNotificariService {
    private readonly alertStore = inject(AlertStore);
    private http = inject(HttpClient);
    private apiServ = inject(ApiService);
    private snackBar = inject(SnackBarService);

    endpoint = 'user/notificari';

    constructor() {
        this.getNotificari();
    }

    getNotificari() {
        this.apiServ.getItem<Notificari[]>(this.endpoint)
            .subscribe(
                (response) => {
                    this.alertStore.setNotificari(response);
                },
                (error: HttpErrorResponse) => {
                    this.snackBar.showError(error);
                }
            );
    }

    delNotificari(item: Notificari) {
        // const params = { mid: item.mid };
        return executa(this.apiServ.delItem(null, `${this.endpoint}/${item.mid}`), () => {
            this.snackBar.showSnackbar("Notificarea a fost stearsa");
            this.getNotificari();
        }, this.snackBar);
    }
}
